// import router from "@/router";
// import store from "@/store";
import { useToast } from "vue-toastification";
const toast = useToast();

export function errorHandler(error) {
  if (!error.response) return toast.error("خطا در برقراری ارتباط با سرور");
  const { status, data } = error.response;
  if (!error.response) return toast.error("خطا در برقراری ارتباط با سرور");
  if (status) {
    data?.data?.messages.forEach((message) => toast.error(message));
  }
  return Promise.reject(data?.data);
}
